import { isServer } from '@/utils/common';

export const BACKEND_API_URL =
  process.env.NEXT_PUBLIC_BACKEND_API_URL || 'http://127.0.0.1:8000/graphql';
export const BACKEND_API_URL_SSR =
  process.env.BACKEND_API_URL_SSR || 'http://127.0.0.1:8000/graphql';

export default isServer() ? BACKEND_API_URL_SSR : BACKEND_API_URL;
